import { Grid } from '@material-ui/core'
import React, { FC } from 'react'

//* utils
import ImgUtil from '../../../utils/img.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

//* components
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

type BlogImageProps = {
  robotImage: string
  headline: string
}

type CollectionProps = {
  item: any
  n: number
}

export const BlogImage: FC<BlogImageProps> = ({ robotImage, headline }) => (
  <Grid item className="BlogCollectionRow__Headline-Container" xs={12} sm={6} md={3}>
    <WrapperImage
      src={ImgUtil.getResizedImageUrl(robotImage, 'width=180')}
      width={180}
      height={180}
      threshold={650}
    />

    <Typography type="header2">{formatInlineCode(headline)}</Typography>
  </Grid>
)

export const Collection: FC<CollectionProps> = ({ item, n }) => {
  const name = item.name
    .toLowerCase()
    .replace(/ *\([^)]*\) */g, '')
    .replace(/\s/g, '-')

  return (
    <Grid item className="BlogCollectionRow__Category-Container" xs={12} sm={6} md={3}>
      <Typography type="header3" className="BlogCollectionRow__Header">
        {item.name}
      </Typography>

      <Typography type="body" className="BlogCollectionRow__Description font__inter">
        {item.description}
      </Typography>

      <Button
        type="text-link"
        theme="light"
        text={item.ctaText}
        icon={true}
        href={`https://www.uipath.com/blog/${name}`}
      />
    </Grid>
  )
}
